import React, {Component} from "react";
import {Table} from "reactstrap";
import "./UserTable.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import history from "../../history";

class UserTable extends Component {

    populateTable() {

        return this.props.users.map((user, i) => {

            return (
                <tr
                    key={i}
                    onClick={() => {
                        history.push(`/users/${user.userId}`);
                    }}
                >
                    <td className="width-20 text-left">{user.firstName} {user.lastName}</td>
                    <td className="width-30 text-left text-truncate">{user.email}</td>
                    <td className="width-20 text-left">
                        {user.appMetaData.applications && user.appMetaData.applications.length > 0 ? user.appMetaData.applications.map(am => {
                            const prod = this.props.userProducts.find(up => am === up.appName);
                            if (prod) {
                                return prod.name;
                            } else {
                                return "";
                            }
                        }).join(", ") : "No products"}
                    </td>
                    <td className="width-10 text-left">{user.isActive ? "Active" : "Inactive"}</td>
                </tr>
            );
        });
    }

    sort(field) {
        if (this.props.sortingField === field && this.props.sortingOrder === 1) {
            return "sort-up";
        } else if (
            this.props.sortingField === field &&
            this.props.sortingOrder === -1
        ) {
            return "sort-down";
        } else {
            return "sort";
        }
    }

    render() {
        return (
            <div className="user-table">
                <Table hover className="table">
                    <thead>
                    <tr>
                        <th className={`width-30 ${this.props.isInFocus && "highlighted"}`}>Name</th>
                        <th
                            className={`width-40 ${this.props.isInFocus && "highlighted"}`}
                            onClick={() => {
                                this.props.handleSortColumn("email");
                            }}
                        >
                            Email{" "}
                            <FontAwesomeIcon
                                className="sort-icon"
                                icon={this.sort("email")}
                            />
                        </th>
                        <th className="width-20">Products</th>
                        <th className="width-10">Status</th>
                    </tr>
                    </thead>
                    <tbody>{this.populateTable()}</tbody>
                </Table>
            </div>
        );
    }
}

export default UserTable;



// WEBPACK FOOTER //
// ./src/user-search/components/UserTable.js